import { SyntheticEvent } from 'react';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, Text, usePopoverMenu } from '@frontend/design-system';

type PhoneNumberPopoverType = {
  getItemProps: ReturnType<typeof usePopoverMenu>['getItemProps'];
  onClick: (e?: SyntheticEvent, overrideNumber?: string) => void;
  data?: { label: string; number: string }[];
  trackingIdSuffix?: string | undefined;
};

export const PhoneNumberPopover = ({ data, getItemProps, trackingIdSuffix, onClick }: PhoneNumberPopoverType) => {
  return (
    <>
      {data?.map(({ label, number }, index) => (
        <>
          <Text css={{ padding: theme.spacing(0, 2) }} color='light' size='medium'>
            {label}
          </Text>
          <PopoverMenuItem
            key={number}
            {...getItemProps({
              index,
              onClick: (e: SyntheticEvent<Element, Event> | undefined) => {
                onClick(e, number);
              },
            })}
            trackingId={trackingIdSuffix}
            label={label}
          >
            {formatPhoneNumber(number)}
          </PopoverMenuItem>
        </>
      ))}
    </>
  );
};
